<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  <div class="sheet">
    <h1 class='header'>Manager Job Signoff - ID: {{ this.job.id }}</h1>
    <hr />

    <div class='form-row'>
      <div class="form-group col-md-4">
        <label for="inputEmail4">PO Number</label>
        <input type="text" name='name' [(ngModel)]='this.job.order.poNumber' [class.is-invalid]='!this.job.order.poNumber' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Tip Site</label>
        <select class='form-control' [class.is-invalid]='this.job.order.tipSiteId === -1' (change)='this.job.order.tipSiteId = +$event.target.value; this.job.order.tipSite = {}; this.job.order.tipSite.id = this.job.order.tipSiteId; this.loadTippingPrice()'>

          <option value='-1'>Select a tip site</option>
          @for (item of this.tips; track item) {
            <option [value]='item.id' [selected]='this.job.order.tipSiteId === item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
    </div>



    @if (this.job.jobAssignment.vehicleId !== -1) {
      <div class='form-row'>
        <div class='form-group col-md-4'>
          <label>Gross Weight</label>
          <input type='text' class='form-control' [(ngModel)]='this.job.weight'/>
        </div>
      </div>
    }
    <div class='form-row'>
      @if (this.job.jobAssignment.vehicleId !== -1) {
        <div class='form-group col-md-4'>
          <label>Tare Weight</label>
          <input type='text' class='form-control' readonly [value]='this.job.jobAssignment.vehicle.tareWeight'/>
        </div>
      }
    </div>
    <div class='form-row'>
      @if (this.job.jobAssignment.vehicleId !== -1) {
        <div class='form-group col-md-4'>
          <label>Net Weight</label>
          <input type='text' class='form-control' [value]='(this.job.weight - this.job.jobAssignment.vehicle.tareWeight).toFixed(2)' readonly/>
        </div>
      }
    </div>

    <h2 class='header'>Order items</h2>

    @if (this.orderLines.length > 0) {
      <table class="table">
        <thead>
          <th>Name</th>
          <th>Qty</th>
          <th>Unit</th>
          <th>Base Price(&pound;)</th>
          <th>Total Price(&pound;)</th>
          <th></th>
        </thead>
        <tbody>
          @for (item of this.orderLines; track item) {
            <tr>
              <td>{{ item.quoteLine ? item.quoteLine.product.name : item.name }}</td>
              <td>
                <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.qty' [readOnly]='item.isPrimaryCharge'>
              </td>
              <td>
                {{ item.quoteLine ? item.quoteLine.product.unitId : item.unitId }}(s)
              </td>
              <td>
                <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.price'>
              </td>
              <td>
                {{ getTotalPriceForOrderLine(item).toFixed(2) }}
              </td>
              <td>
                <input type='checkbox' [(ngModel)]="item.isPrimaryCharge"
                  [ngModelOptions]="{standalone: true}" />&nbsp;
                  Is Primary Charge?
                </td>
              </tr>
            }
          </tbody>
        </table>
      }

      <button type="submit" class="btn btn-success" (click)='save()'>Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/job-signoff/artic'>Cancel</button>
    </div>

  </div>
